"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.listTicketsQuerySchema = exports.addTicketEventSchema = exports.updateTicketSchema = exports.createTicketSchema = exports.ticketNotificationSchema = exports.ticketEventSchema = exports.ticketSchema = exports.ticketAttachmentSchema = exports.notificationStatuses = exports.notificationChannels = exports.ticketActorTypes = exports.ticketEventTypes = exports.ticketPriorityValues = exports.ticketStatusValues = void 0;
const zod_1 = require("zod");
exports.ticketStatusValues = ["OPEN", "ACKNOWLEDGED", "IN_PROGRESS", "ESCALATED", "RESOLVED", "CLOSED"];
exports.ticketPriorityValues = ["P1", "P2", "P3", "P4"];
exports.ticketEventTypes = ["STATUS_CHANGE", "COMMENT", "ESCALATION", "NOTIFICATION", "SYSTEM"];
exports.ticketActorTypes = ["SYSTEM", "USER", "SERVICE"];
exports.notificationChannels = ["EMAIL", "SMS", "PUSH", "WEBHOOK", "IN_APP"];
exports.notificationStatuses = ["PENDING", "SENT", "DELIVERED", "FAILED", "ACKNOWLEDGED"];
const metadataSchema = zod_1.z.record(zod_1.z.string(), zod_1.z.unknown()).optional();
exports.ticketAttachmentSchema = zod_1.z
    .object({
    id: zod_1.z.string(),
    eventId: zod_1.z.string(),
    url: zod_1.z.string().min(1),
    mimeType: zod_1.z.string().optional().nullable(),
    sizeBytes: zod_1.z.number().int().optional().nullable(),
    metadata: metadataSchema,
})
    .strict();
exports.ticketSchema = zod_1.z
    .object({
    id: zod_1.z.string(),
    tenantId: zod_1.z.string(),
    organizationId: zod_1.z.string().optional().nullable(),
    fleetId: zod_1.z.string().optional().nullable(),
    deviceId: zod_1.z.string().optional().nullable(),
    driverId: zod_1.z.string().optional().nullable(),
    vehicleId: zod_1.z.string().optional().nullable(),
    tripId: zod_1.z.string().optional().nullable(),
    triggerId: zod_1.z.string().optional().nullable(),
    title: zod_1.z.string(),
    description: zod_1.z.string().optional().nullable(),
    status: zod_1.z.enum(exports.ticketStatusValues),
    priority: zod_1.z.enum(exports.ticketPriorityValues),
    severity: zod_1.z.string().optional().nullable(),
    category: zod_1.z.string().optional().nullable(),
    source: zod_1.z.string().optional().nullable(),
    impactScore: zod_1.z.number().optional().nullable(),
    slaTargetAt: zod_1.z.string().datetime().optional().nullable(),
    acknowledgedAt: zod_1.z.string().datetime().optional().nullable(),
    resolvedAt: zod_1.z.string().datetime().optional().nullable(),
    closedAt: zod_1.z.string().datetime().optional().nullable(),
    assignedTeamId: zod_1.z.string().optional().nullable(),
    assigneeUserId: zod_1.z.string().optional().nullable(),
    metadata: metadataSchema,
    createdAt: zod_1.z.string().datetime(),
    updatedAt: zod_1.z.string().datetime(),
})
    .strict();
exports.ticketEventSchema = zod_1.z
    .object({
    id: zod_1.z.string(),
    ticketId: zod_1.z.string(),
    type: zod_1.z.enum(exports.ticketEventTypes),
    actorType: zod_1.z.enum(exports.ticketActorTypes),
    actorId: zod_1.z.string().optional().nullable(),
    body: zod_1.z.string().optional().nullable(),
    data: metadataSchema,
    attachments: zod_1.z.array(exports.ticketAttachmentSchema).optional(),
    createdAt: zod_1.z.string().datetime(),
})
    .strict();
exports.ticketNotificationSchema = zod_1.z
    .object({
    id: zod_1.z.string(),
    ticketId: zod_1.z.string(),
    channel: zod_1.z.enum(exports.notificationChannels),
    destination: zod_1.z.string(),
    status: zod_1.z.enum(exports.notificationStatuses),
    payload: metadataSchema,
    response: metadataSchema,
    errorMessage: zod_1.z.string().optional().nullable(),
    sentAt: zod_1.z.string().datetime().optional().nullable(),
    deliveredAt: zod_1.z.string().datetime().optional().nullable(),
    acknowledgedAt: zod_1.z.string().datetime().optional().nullable(),
    createdAt: zod_1.z.string().datetime(),
})
    .strict();
exports.createTicketSchema = zod_1.z
    .object({
    tenantId: zod_1.z.string(),
    title: zod_1.z.string().min(1),
    description: zod_1.z.string().optional(),
    status: zod_1.z.enum(exports.ticketStatusValues).optional(),
    priority: zod_1.z.enum(exports.ticketPriorityValues).optional(),
    severity: zod_1.z.string().optional(),
    category: zod_1.z.string().optional(),
    source: zod_1.z.string().optional(),
    impactScore: zod_1.z.number().optional(),
    slaTargetAt: zod_1.z.string().datetime().optional(),
    organizationId: zod_1.z.string().optional(),
    fleetId: zod_1.z.string().optional(),
    deviceId: zod_1.z.string().optional(),
    driverId: zod_1.z.string().optional(),
    vehicleId: zod_1.z.string().optional(),
    tripId: zod_1.z.string().optional(),
    triggerId: zod_1.z.string().optional(),
    assignedTeamId: zod_1.z.string().optional(),
    assigneeUserId: zod_1.z.string().optional(),
    metadata: metadataSchema,
})
    .strict();
exports.updateTicketSchema = zod_1.z
    .object({
    title: zod_1.z.string().min(1).optional(),
    description: zod_1.z.string().optional(),
    status: zod_1.z.enum(exports.ticketStatusValues).optional(),
    priority: zod_1.z.enum(exports.ticketPriorityValues).optional(),
    severity: zod_1.z.string().optional(),
    category: zod_1.z.string().optional(),
    source: zod_1.z.string().optional(),
    impactScore: zod_1.z.number().optional().nullable(),
    slaTargetAt: zod_1.z.string().datetime().optional().nullable(),
    assignedTeamId: zod_1.z.string().optional().nullable(),
    assigneeUserId: zod_1.z.string().optional().nullable(),
    metadata: metadataSchema,
})
    .strict();
exports.addTicketEventSchema = zod_1.z
    .object({
    type: zod_1.z.enum(exports.ticketEventTypes),
    actorType: zod_1.z.enum(exports.ticketActorTypes),
    actorId: zod_1.z.string().optional(),
    body: zod_1.z.string().optional(),
    data: metadataSchema,
    attachments: zod_1.z
        .array(zod_1.z
        .object({
        url: zod_1.z.string().min(1),
        mimeType: zod_1.z.string().optional(),
        sizeBytes: zod_1.z.number().int().nonnegative().optional(),
        metadata: metadataSchema,
    })
        .strict())
        .optional(),
})
    .strict();
exports.listTicketsQuerySchema = zod_1.z
    .object({
    tenantId: zod_1.z.string(),
    status: zod_1.z.enum(exports.ticketStatusValues).optional(),
    priority: zod_1.z.enum(exports.ticketPriorityValues).optional(),
    triggerId: zod_1.z.string().optional(),
    deviceId: zod_1.z.string().optional(),
    driverId: zod_1.z.string().optional(),
    vehicleId: zod_1.z.string().optional(),
    tripId: zod_1.z.string().optional(),
    assignedTeamId: zod_1.z.string().optional(),
    assigneeUserId: zod_1.z.string().optional(),
    search: zod_1.z.string().optional(),
    limit: zod_1.z.number().int().min(1).max(200).optional(),
    cursor: zod_1.z.string().optional(),
})
    .strict();
